import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { throttle } from "throttle-debounce";
import { findByType } from "../util/findByType";
import * as styles from "./InfoPanel.module.scss";

const View = () => null;
View.displayName = "InfoPanelView";
const Info = () => null;
Info.displayName = "InfoPaneInfo";

const InfoPanel = ({ children, isActive }) => {
	const infoEl = useRef(null);
	const [height, setHeight] = useState(0);

	useEffect(() => {
		setHeight(infoEl?.current?.clientHeight);
	}, [infoEl, isActive]);

	useEffect(() => {
		const handleResize = throttle(200, () => {
			setHeight(infoEl?.current?.clientHeight);
		});

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	});

	const renderView = () => {
		const view = findByType(children, View);
		if (!view) {
			return null;
		}
		return view.props.children;
	};

	const renderInfo = () => {
		const info = findByType(children, Info);
		if (!info) {
			return null;
		}
		return (
			isActive && (
				<div
					className={cx(styles.info, info.props.className)}
					ref={infoEl}
					data-testid="infoPanel-info-view">
					{info.props.children}
				</div>
			)
		);
	};
	return (
		<div className={styles.infoProfile} style={{ marginBottom: `${height || 0}px` }}>
			{renderView()}
			{renderInfo()}
		</div>
	);
};
InfoPanel.View = View;
InfoPanel.Info = Info;
InfoPanel.propTypes = {
	children: PropTypes.oneOfType([View, Info]).isRequired,
	isActive: PropTypes.bool,
};
InfoPanel.defaultProps = {
	isActive: false,
};

export default InfoPanel;
export { InfoPanel };
